module.exports = __webpack_public_path__ + "static/media/logos-home.2b0ff7a4.png";